// @ts-nocheck

import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'

import { colors } from '@lmc/common/constants'
import { hexToRgbA } from '../../../../common/utils'
import { ProfileBadge } from '../../ProfileBadge'

export default function EmarResidentMedicationCell(props) {
  const { PRN, controlledDrug, customName, id, medication, resident } = props

  return (
    <div>
      <div style={styles.container}>
        <Link to={`/residents/${resident}/emar/${id}/stock`}>
          <span style={styles.blackText}>
            {customName || (medication && medication.name)}
          </span>
        </Link>
        {controlledDrug && (
          <ProfileBadge
            backgroundColor={hexToRgbA(colors.red, 0.2)}
            badgeStyle={styles.badge}
            badgeText="CD"
            textColor={colors.red}
          />
        )}
        {PRN && (
          <ProfileBadge
            backgroundColor={hexToRgbA(colors.blue, 0.2)}
            badgeStyle={styles.badge}
            badgeText="PRN"
            textColor={colors.blue}
          />
        )}
      </div>
    </div>
  )
}

const styles = {
  container: {
    paddingTop: 3,
    display: 'flex',
  },
  badge: {
    fontSize: 12,
    height: 25,
    fontWeight: 'bold',
    marginLeft: 8,
    padding: '4px',
    borderRadius: 15,
  },
  blackText: {
    color: colors.black,
  },
}

EmarResidentMedicationCell.propTypes = {
  PRN: PropTypes.bool,
  controlledDrug: PropTypes.bool,
  customName: PropTypes.string,
  id: PropTypes.string.isRequired,
  medication: PropTypes.object,
  resident: PropTypes.string.isRequired,
}
